module.exports = __webpack_public_path__ + "res/img_share.e2b1fb2279a3e9ff9ac621f760b64369.png";